import { Field, Select, TextArea } from "@/components/FormField";
import { STATES, TIME_SLOTS } from "../constants";

function tomorrowIso() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

export default function LocationSchedule({ form, upd }) {
  const minDate = tomorrowIso();
  return (
    <div>
      <div className="font-serif-display text-xl text-[var(--yp-primary)]">Where should we visit?</div>
      <p className="text-sm text-[var(--yp-muted)] mt-1">Provide the project/site location and your preferred schedule.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        <TextArea id="sr-address" label="Complete site address" required value={form.address} onChange={(v) => upd("address", v)} className="sm:col-span-2" />
        <Field id="sr-pincode" label="Pin code" required value={form.pincode} onChange={(v) => upd("pincode", v.replace(/\D/g, "").slice(0, 6))} />
        <Field id="sr-city" label="City / town" required value={form.city} onChange={(v) => upd("city", v)} />
        <Field id="sr-district" label="District" value={form.district} onChange={(v) => upd("district", v)} />
        <Select id="sr-state" label="State" required value={form.state} onChange={(v) => upd("state", v)} options={STATES} />
        <Field id="sr-map-link" label="Google Maps link" type="url" value={form.map_link} onChange={(v) => upd("map_link", v)} placeholder="Paste location link" />
        <Field id="sr-date" label="Preferred visit date" type="date" required min={minDate} value={form.date} onChange={(v) => upd("date", v)} />
        <Select id="sr-time" label="Preferred time" required value={form.time} onChange={(v) => upd("time", v)} options={TIME_SLOTS} />
        <Field id="sr-alt-date" label="Alternative date" type="date" min={minDate} value={form.alt_date} onChange={(v) => upd("alt_date", v)} />
      </div>
    </div>
  );
}
